import * as actionTypes from 'modules/interventions/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @typedef {boolean} IsLoadingState */

/** @type {IsLoadingState} */
const initialState = false;

const set = () => true;
const reset = () => false;

export default createReducer(initialState, {
  [actionTypes.IMPORT_AUDITS_OR_TSCANS]: set,
  [actionTypes.IMPORT_AUDITS_OR_TSCANS_FAILURE]: reset,
  [actionTypes.IMPORT_AUDITS_OR_TSCANS_SUCCESS]: reset,
});
